import { useFormContext } from 'react-hook-form';

import type { QConfigDuplicationFormInput } from './qconfig-duplication-form-schema';

export const useQConfigDuplicationFormContext = useFormContext<QConfigDuplicationFormInput>;
